
  document.addEventListener('DOMContentLoaded', function () {
    const watermark = document.querySelector('.tmenu-watermark');
    if (watermark) {
      watermark.style.display = 'none';
    }
  });

(function () {
  // Run only once
  if (window.__safeMutationObserverLoaded) return;
  window.__safeMutationObserverLoaded = true;

  function observeProductTiles() {
    const tiles = document.querySelectorAll('form[id^="add-to-cart-"]');

    tiles.forEach(tile => {
      // Store initial content snapshot
      let initialLength = tile.innerHTML.length;
      let timeout = null;

      const observer = new MutationObserver(mutations => {
        // Debounce rapid mutations
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          const currentLength = tile.innerHTML.length;

          // Ignore small DOM changes (button text, price updates, etc.)
          if (Math.abs(currentLength - initialLength) < 50) {
            return;
          }

          // Update snapshot instead of warning
          initialLength = currentLength;
        }, 150);
      });

      observer.observe(tile, {
        childList: true,
        subtree: true
      });
    });
  }

  // Delay observer until Shopify & apps finish rendering
  if (document.readyState === 'complete') {
    setTimeout(observeProductTiles, 800);
  } else {
    window.addEventListener('load', () => {
      setTimeout(observeProductTiles, 800);
    });
  }
})();
